// @ts-nocheck

import {
  getObjectKeysAsObject,
  setContextWithKey,
  ParentState,
} from "@hopper-b2b/checkout";
import { assign } from "xstate";
import type {
  ChangeGuestInformationEvent,
  SetSessionInfoEvent,
} from "./events";
import type { PartialHopperCheckoutContext } from "./types";

export const AuthActions = {
  onChangeGuestInformation: assign(
    (
      context: PartialHopperCheckoutContext,
      event: ChangeGuestInformationEvent
    ) => {
      const guestUser = context.auth.guestUser;

      const modifiedGuestUser = { ...guestUser, ...event.guestUser };

      return setContextWithKey(context, "auth.guestUser", modifiedGuestUser);
    }
  ),
  setSessionInfo: assign(
    (context: PartialHopperCheckoutContext, event: SetSessionInfoEvent) => {
      return setContextWithKey(context, "sessionInfo", event.sessionInfo);
    }
  ),
  setGuestAsCurrentFlightPassenger: assign(
    (context: PartialHopperCheckoutContext, _event) =>
      setContextWithKey(
        context,
        `${ParentState.passengerInformation}.currentUserPassenger`,
        { ...context.auth.guestUser }
      )
  ),
};

export const AuthActionTypes = getObjectKeysAsObject(AuthActions);
